module.exports = __webpack_public_path__ + "img/pilot-assesment.0bce8029.png";